import React, { useEffect, useState } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker"
import moment from "moment";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { CalendarMonth } from "@mui/icons-material";

const CustomMultipleInput = (props) => {
    const { openCalendar, value, handleValueChange, disabled, name, id, required, placeholder, onBlur } = props;
    return (
        <div className="input-group">
            <input type="text" onBlur={onBlur} onFocus={openCalendar} onChange={handleValueChange} placeholder={placeholder}
                required={required} disabled={disabled} name={name} id={id} value={value} className="form-control"
                aria-label="Dollar amount (with dot and two decimal places)" />
            <span onClick={openCalendar} className="input-group-text cursor-pointer"><CalendarMonth /></span>
        </div>
    )
}

const CustomDateInput = (props) => {
    const { value, onChange, size, id, name, required, type, placeholder, inputFormat, disabled, onBlur } = props;
    const [startDate, setStartDate] = useState();
    useEffect(() => {
        if (value) {
            setStartDate(moment(value).toDate());
        }
    }, [value]);

    const hasTime = type === 'datetime-local';
    const format2 = inputFormat ?? (hasTime ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD");

    return (
        <DatePicker
            format={format2}
            inputClass={`form-control  ${size === 'small' ? ' form-control-sm' : ''}`}
            containerClassName={'d-block'}
            value={startDate}
            name={name}
            id={id}
            render={<CustomMultipleInput disabled={disabled} name={name} required={required} id={id}
                placeholder={placeholder} />}
            required={required}
            placeholder={placeholder}
            disabled={disabled}
            zIndex={9999}
            onClose={() => {

            }}
            onChange={(value) => {
                let v = (value instanceof DateObject) ? value.toDate() : undefined;

                setStartDate(v);

                if (onChange) {
                    onChange(moment(v).format(format2));
                }

            }}
            plugins={hasTime ? [
                <TimePicker
                    hideSeconds
                    style={{ minWidth: "100px" }}
                />
            ] : []}
        />
    );
}

export default CustomDateInput;